import { Component } from '@angular/core';
import { OfferModalAction } from '../../../../../shared/directives/offer-modal-action/offer-modal-action';
import { Cancel } from 'smartauction-frontend-micro-library';
import { TranslocoDirective } from '@jsverse/transloco';

import { OfferModalsHeaderComponent } from 'src/shared/ui/comment/modal-actions/offer-header/offer-modals-header.component';
import { OfferHistoryComponent } from '../../offer-history/offer-history.component';
import { ModalCloseComponent } from 'src/shared/ui/comment/modal-actions/modal-close/modal-close.component';

@Component({
    selector: 'app-cancel-offer',
    templateUrl: './cancel-offer.component.html',
    styleUrls: ['./cancel-offer.component.scss'],
    imports: [
        TranslocoDirective,
        OfferModalsHeaderComponent,
        OfferHistoryComponent,
        ModalCloseComponent
    ]
})
export class CancelOfferComponent extends OfferModalAction {
  cancel() {
    this.event.emit(new Cancel());
  }
}
